module.exports = __webpack_public_path__ + "img/icon09.a4dd0a2c.png";